//React imports
import React, { useEffect } from "react";

import FooterComponent from "../../components/home/FooterComponent.js";

//Imports assets such as images
import NavBarComponent from "../../components/navBar/NavBarComponent.js";
import CashbackInfoComponent from "../../components/solutions/cashbackInfo/cashbackInfo.jsx";

export default function CashbackInfoPage() {
    return (
        <div>
            <div className="updated-page-wrapper">
                <div className="">

                    <NavBarComponent />
                </div>

                {/* <HeaderComponent page="pricing" /> */}


                <CashbackInfoComponent />



                <FooterComponent />
            </div>
        </div>
    );
}
